import { unzip } from "unzipit";

export async function unzipData(url: string) {
  const { entries } = await unzip(url);
  const data = await entries["data.json"].json();
  return {
    success: true,
    data: data,
  };
}
